import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import cssModules from 'react-css-modules'
import styles from './profile_header.less'
import Strip from 'components/strip'
import Header from 'components/pages/campaign/header'
import { glimpseRoute } from 'lib/route_utils'
import { getI18n } from 'client/i18n'

import AddPhoto from '!!babel-loader!react-svg-loader!images/addphoto.svg' // eslint-disable-line import/no-unresolved

const i18n = getI18n('components/pages/campaign')

class ProfileHeader extends React.Component {
  static propTypes = {
    backgroundImage: PropTypes.string,
    backgroundPan: PropTypes.number,
    gradientColor: PropTypes.string,
    children: PropTypes.element,
    avatarElement: PropTypes.element,
    preview: PropTypes.bool,
    showHeader: PropTypes.bool,
    showHubLink: PropTypes.bool,
  }

  render() {
    return (
      <div styleName="profile-header-container">
        <div styleName="profile-header">
          <div
            styleName={`strip-container ${
              this.props.backgroundImage ? 'has-image' : ''
            }`}
          >
            <Strip
              isResponsive
              isFullscreen
              backgroundImage={this.props.backgroundImage}
              backgroundPan={this.props.backgroundPan}
              gradientColor={this.props.gradientColor}
            />
          </div>
          {this.props.backgroundImage && <div styleName="shadow-overlay" />}
          {this.props.showHeader && (
            <div styleName="header-grid-container">
              <div styleName="header-container">
                <Header type="transparent" inGrid />
              </div>
            </div>
          )}
          {this.props.showHubLink && (
            <div styleName="header-grid-container">
              <a href="/pools" styleName="hub-link">
                <span styleName="hub-link-arrow">{'\u21E0'}</span>
                <span styleName="hub-link-text">{i18n('your_pools')}</span>
              </a>
            </div>
          )}
        </div>
        {this.props.preview && (
          <div styleName="add-photo-container">
            <div styleName="add-photo-grid">
              <Link
                to={{
                  pathname: glimpseRoute('edit', 'cover'),
                  fromPreview: true,
                }}
              >
                <AddPhoto width="36" height="31" styleName="add-photo-icon" />
              </Link>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default cssModules(ProfileHeader, styles, { allowMultiple: true })
